export default __webpack_public_path__ + "static/media/ic_close_chat.a824f582.svg";